/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, HostListener, OnInit } from '@angular/core';
import { PasswordStrengthComponent } from "../password-strength/password-strength.component";
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { STATUS_ACTIVE } from '../../../data-models/user-login';
import { ReactiveFormsModule } from '@angular/forms';
import { AuthenticationService } from '../../../services/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { SUCCESS } from '../../../data-models/user-data';
import { CommonModule } from '@angular/common';
import { environment } from '../../../../environments/environments';
import { SharedModule } from '../../shared/shared.moudle';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    PasswordStrengthComponent,
    CommonModule,
    SharedModule,
    ReactiveFormsModule
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  show_side_panel = false
  loginForm: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
    saveme: new FormControl(true, [Validators.required])
  })
  show = false;
  submmited = false;
  hide = true;
  not_academy = false
  is_parents_or_child = false
  error_text = 'Password Incorrect!'
  error = false
  isLoggedin?: boolean = undefined;
  profile = ""
  pwa_url: string = environment.pwa_url
  isMultiple = false;
  academy_list: any = [];
  user_info: any = {};
  isLoggingIn: boolean = false;
  private loggingInTimeout: any = null;

  constructor(
    private auth: AuthenticationService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required]),
      saveme: new FormControl(true, [Validators.required])
    })
  }


  // This listens for Enter key globally
  @HostListener('document:keydown.enter', ['$event'])
  handleEnterKey(event: KeyboardEvent) {
    if (this.loginForm.valid && !this.isLoggingIn) {
      this.onLogin();
    }
  }

  @HostListener('window:offline')
  onOffline() {
    if (this.isLoggingIn) {
      this.stopLoginLoader();
      this.toastr.error("No internet connection. Please check your network and try again.", 'No Internet', {
        progressBar: true,
        closeButton: true
      });
    }
  }

  @HostListener('window:online')
  onOnline() {
    this.toastr.success("You're back online. You can try logging in again.", 'Connected', {
      progressBar: true,
      closeButton: true
    });
  }

  private stopLoginLoader() {
    this.isLoggingIn = false;
    if (this.loggingInTimeout) {
      clearTimeout(this.loggingInTimeout);
      this.loggingInTimeout = null;
    }
  }

  private scheduleLoginLoaderReset() {
    if (this.loggingInTimeout) {
      clearTimeout(this.loggingInTimeout);
    }
    this.loggingInTimeout = setTimeout(() => {
      this.isLoggingIn = false;
      this.loggingInTimeout = null;
    }, 8000);
  }

  onImgError(event: any) {
    event.target.src = 'images/samples/ic_profile.png'
  }

  toggle() {
    this.not_academy = false
  }

  /**
   * Function to toggle the password.
   */
  togglePassword() {
    this.hide = !this.hide;
  }

  /**
   * On login Click.
   */
  onLogin() {
    this.submmited = true
    if (this.isLoggingIn) {
      return;
    }
    if (!navigator.onLine) {
      this.toastr.error("No internet connection. Please check your network and try again.", 'No Internet', {
        progressBar: true,
        closeButton: true
      });
      return;
    }
    // console.log(this.loginForm.get('email')?.value)
    // console.log(this.loginForm.get('password')?.value)
    if (this.loginForm.get('email')?.value && this.loginForm.get('password')?.value) {
      this.isLoggingIn = true;
      this.login(this.loginForm.get('email')?.value.trim().toLowerCase(), this.loginForm.get('password')?.value)
    }
    else {
      // console.log("invalid form")
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  login(email: string, password: string,keep_session?: boolean, delegate?: any) {
    this.auth.checkEmail(email.trim().toLowerCase()).subscribe({
      next:(result: any)=>{
        if (result.active_status === STATUS_ACTIVE) {
          var is_academy = result.profile_type.filter((item: any) => {
            return item.toLowerCase().includes(("Academy").toLowerCase());
          }).length > 0 || result.profile_type.filter((item: any) => {
            return item.toLowerCase().includes(("Coach").toLowerCase());
          }).length > 0 || result.profile_type.filter((item: any) => {
            return item.toLowerCase().includes(("Admin").toLowerCase());
          }).length > 0

          if (is_academy) {
            if (result.profile_type.filter((item: any) => {
              return item.toLowerCase().includes(("Academy").toLowerCase());
            }).length > 0) {
              // this.auth.login(email, password, result, keep_session)
              this.auth.attemptLogin(email.trim().toLowerCase(), password, keep_session, undefined, () => this.stopLoginLoader())
              this.scheduleLoginLoaderReset();
            } else {
              this.auth.getUserDelegates(result._id).subscribe({
                next: (res: any) => {
                  // console.log(res)
                  if (res.response == SUCCESS) {
                    if (res.data == null || res.data.length == 0) {
                      this.toastr.warning(`Looks like you have not been assigned a role yet. Please contact your Academy Manager to assign a role.`, `Role Not Assigned.`)
                      this.stopLoginLoader();
                    } else if (res.data.length == 1) {
                      // this.auth.login(email, password, result, keep_session, res.data[0])
                      this.auth.attemptLogin(email.trim().toLowerCase(), password, keep_session, res.data[0], () => this.stopLoginLoader())
                      this.scheduleLoginLoaderReset();
                    } else {
                      this.isMultiple = true
                      this.academy_list = res.data || []
                      this.user_info = {
                        email: email.trim().toLowerCase(),
                        password: password,
                        result: result,
                        keep_session: keep_session,
                      }
                      // console.log(this.academy_list)
                      this.toastr.warning(`Looks like you have been assigned a role in multiple academies, please select an Academy to continue login.`, `Multiple Academy Found.`)
                      this.stopLoginLoader();
                    }
                  } else {
                    this.stopLoginLoader();
                  }
                },
                error: (err: any) => {
                  console.error(err);
                  this.notifyNetworkOrServerError(err);
                  this.stopLoginLoader();
                }
              })
            }
          } else {
            this.profile = result.profile_type[0].toString()
            this.non_academy_user()
            this.stopLoginLoader();
          }
        } else if (result['error'] === "no results found") {
          this.toastr.warning(
            "The email address you entered is incorrect. Please check and try again.",
            "Incorrect Email",
            {
              progressBar: true,
              closeButton: true
            }
          );
          this.stopLoginLoader();
        } else {
          this.toastr.warning("Your account has been deactivated. Contact Dartle support.", 'Warning', {
            progressBar: true,
            closeButton: true
          })
          this.stopLoginLoader();
        }
      },
      error: (err: any) => {
        console.error(err);
        this.notifyNetworkOrServerError(err);
        this.stopLoginLoader();
      }
    })
  }

  private notifyNetworkOrServerError(err: any) {
    if (!navigator.onLine || err?.status === 0) {
      this.toastr.error("No internet connection. Please check your network and try again.", 'No Internet', {
        progressBar: true,
        closeButton: true
      });
    } else {
      this.toastr.error("Something went wrong. Please try again.", 'Login Failed', {
        progressBar: true,
        closeButton: true
      });
    }
  }

  non_academy_user() {
    this.not_academy = true
    this.toastr.warning("Only Academy can login to web app.", 'Wrong Account Type', {
      progressBar: true,
      closeButton: true
    })
    this.is_parents_or_child = this.profile == "Player"
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  academySelector(delegate: any) {
    if (this.isLoggingIn) {
      return;
    }
    this.isLoggingIn = true;
    this.auth.attemptLogin(this.user_info.email.trim().toLowerCase(), this.user_info.password, this.user_info.keep_session, delegate, () => this.stopLoginLoader())
    this.scheduleLoginLoaderReset();
    // this.auth.login(this.user_info.email, this.user_info.password, this.user_info.result, this.user_info.keep_session, delegate)
  }

}
